import { TaskPriorityUnionType } from '@api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Group, Text } from '@mantine/core';
import { getTaskPriorityPresentation } from '../../../../../../utils';

type PriorityOptionPropsType = {
  priority: TaskPriorityUnionType;
  label: string;
};

export const PriorityOption: React.FC<PriorityOptionPropsType> = ({
  priority,
  label,
}) => {
  const presentation = getTaskPriorityPresentation(priority);

  return (
    <Group gap="xs">
      <FontAwesomeIcon
        icon={presentation.icon}
        size="xs"
        color={presentation.color}
      />
      <Text size="sm">{label}</Text>
    </Group>
  );
};
